<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          autocomplete="off"
        >
          <div class="lg:max-w-detail lg:mr-auto">
            <div class="lg:mb-4">
            </div>
            <div class="lg:mb-2" v-if="role === 7 || role === 8 || role === 3">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('clients.entity_name')}}</label>
              <div class="flex justify-between">
                <el-form-item prop="clienteId" class="w-full">
                  <base-el-select class="w-full" :options="clientes" v-model="form.clienteId" filterable clearable :disabled="!isCreate" :loading="loadingClientes" />
                </el-form-item>
                <base-button v-if="!isCreate" class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.name')}}</label>
                <el-form-item prop="name">
                  <el-input
                    :disabled="form.tipo === 1"
                    clearable
                    class="w-full"
                    v-model="form.name"
                    maxlength='50'
                  />
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="flex items-center mb-1">
                <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon v-if="isCreate"/>{{$t('configurations.group_type')}}</label>
                <base-tooltip-icon-html size="sm" :content="tooltipTipoGrupo" class="ml-2"/>
              </div>
              <el-form-item prop="tipo">
                <base-el-select class="w-full" :options="tiposGrupoFiltered" v-model="form.tipo" :clearable="isCreate" :disabled="!isCreate" />
              </el-form-item>
            </div>

            <!-- <div class="lg:mb-2" v-if="form.tipo == 2 || form.tipo === 3">
              <div class="mandatory">
                <div class="flex flex-row items-center  mb-1">
                  <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon v-if="form.tipo === 3"/>{{$tc('users.email', 2)}}</label>
                  <base-tooltip-icon size="sm" :content="contentTooltipEmail" class="ml-2"/>
                </div>
                <el-form-item prop="email">
                  <el-input
                    :disabled="form.tipo === 1"
                    clearable
                    class="w-full"
                    v-model="form.email"
                    maxlength='255'
                  />
                </el-form-item>
              </div>
            </div> -->

            <div class="mb-6">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <el-switch class="switch-text break-normal" :disabled="form.tipo === 3 || form.tipo === 1 || !hasPermissionEditVisiblity" v-model="form.verTodoGroups" :active-text="$t('configurations.ver_todo_groups')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipverTodoGroups" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <el-switch class="switch-text break-normal" :disabled="form.tipo === 3 || form.tipo === 1 || !hasPermissionEditVisiblity" v-model="form.verTodoStatuses" :active-text="$t('configurations.ver_todo_statuses')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <el-switch class="switch-text break-normal" :disabled="form.tipo === 3 || form.tipo === 1 || !hasPermissionEditVisiblity" v-model="form.verTodoCompanies" :active-text="$t('configurations.ver_todo_companies')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies" class="ml-1"/>
                </div>
              </div>
            </div>
            <!-- <div class="mb-6" v-if="!isCreate">
              <div class="flex flex-row items-center mb-4 lg:mb-0">
                <el-switch class="switch-text break-normal" disabled v-model="form.EnUso" :active-text="$t('app.in_use')"></el-switch>
              </div>
            </div> -->
            
            <h3 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{$t('avisos.header')}}</h3>
            <div class="mb-4">
              <div>
                <el-switch class="switch-text break-normal" v-model="form.EnviarAvisos" :active-text="$t('app.send_alerts')"></el-switch>
              </div>
            </div>
            <div class="mb-4">
              <div>
                <el-switch class="switch-text break-normal" v-model="form.EnviarAvisosUsuarios" :active-text="$t('configurations.send_alerts_users')"></el-switch>
              </div>
            </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_nueva_emitida')}}</label>
                  <el-form-item prop="EmailAvisoNuevaEmitida" ref="EmailAvisoNuevaEmitida">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.EmailAvisoNuevaEmitida"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_nueva_recibida')}}</label>
                  <el-form-item prop="EmailAvisoNuevaRecibida" ref="EmailAvisoNuevaRecibida">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.EmailAvisoNuevaRecibida"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_cambio_estado')}}</label>
                  <el-form-item prop="EmailAvisoCambioEstado" ref="EmailAvisoCambioEstado">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.EmailAvisoCambioEstado"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_aviso_vincul')}}</label>
                  <el-form-item prop="EmailAvisoVinculaciones" ref="EmailAvisoVinculaciones">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.EmailAvisoVinculaciones"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('app.save')"
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
    </template>
  </detail-layout-full-width>
</template>

<script>
import { bus } from '@/main'
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import { getClients } from '@/services/clients/getClients'
import { getGroup } from '@/services/configurations/groups/getGroup'
import { newGroup } from '@/services/configurations/groups/newGroup'
import { updateGroup } from '@/services/configurations/groups/updateGroup'
import { getGroupTemplate } from '@/services/configurations/groups/template/getGroupTemplate'

import { i18n } from '@/i18n'
import { email as emailRegex } from '@/utils/regex'

function isValidEmail (value) {
  return value.split(';').every(item => emailRegex.test(item))
}

export default {
  /* eslint-disable camelcase */
  name: 'group-detail',
  components: {
    DetailLayoutFullWidth,
  },
  data: function () {
    return {
      searchView: false,
      activeName: 'es',
      localUserId: null,
      header: {
        title: i18n.t('groups.header_long'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/groups'
      },
      maxLengthCorreos: 500,
      form: this.getDefaultForm(),
      loadingClientes: false,
      clientes: [],
      tooltipverTodoGroups: i18n.t('tooltip.groups.ver_todo_groups'),
      tooltipVerTodoStatuses: i18n.t('tooltip.groups.ver_todo_statuses'),
      tooltipVerTodoCompanies: i18n.t('tooltip.groups.ver_todo_companies'),
      tooltipTipoGrupo: i18n.t('tooltip.html.groups.tipo_grupo'),
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading || this.loadingClientes
    },
    id: function () {
      return this.$route.params.id
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasPermissionEditVisiblity () {
      return this.$store.getters['auth/hasPermissionEditVisiblity']
    },
    hasModuleGruposReparto () {
      return this.$store.getters['auth/hasModuleGruposReparto']
    },
    tiposGrupoFiltered () {
      let groups = this.$store.getters['config/TIPOS_GRUPO']
      if (this.isCreate) {
        if (this.hasModuleGruposReparto) groups = groups.filter(x => x.create)
        else groups = groups.filter(x => x.create).filter(x => x.id !== 3)
      }
      return groups.map(x => ({ label: x.name, value: x.id }))
    },
    // contentTooltipEmail () {
    //   if (this.form.tipo === 2) return 'Bandeja de emails utilizada para avisos de facturas nuevas, descargadas y tramitadas, en caso de tener configurado los avisos a grupos'
    //   if (this.form.tipo === 3) return 'Bandeja de emails utilizada para avisos de facturas descargadas'
    //   return ''
    // },
    formatCodigoPaisSMSAvisoDescargada () {
      if (this.form?.CodigoPaisSMSAvisoDescargada === '0034') return '+34'
      return i18n.t('app.unknown')
    },
    hasPermModuleSMS () {
      return this.$store.getters['auth/hasModuleEnvioSMS']
    },
    isTipoReparto () {
      return this.form?.tipo === 3
    },
    rules () {
      return {
        clienteId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        tipo: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        EmailAvisoNuevaEmitida: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoNuevaRecibida: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoCambioEstado: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoVinculaciones: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.tipo': {
      deep: true,
      immediate: true,
      handler: 'watchFormHandlerTipo'
    },
  },
  created: async function () {
    const breadcrumbs = []

    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(`${dataClients.msgError} [${dataClients.codError}]`)
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, value: x.idCliente }))
      this.loadingClientes = false

      breadcrumbs.push({
        path: this.role === 3 ? 'configurationssa' : 'configurations',
        name: i18n.t('configurations.header')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: i18n.t('configurations.header')
      })
    }
    breadcrumbs.push({ path: 'configurations/groups', name: i18n.t('groups.header') })

    if (!this.isCreate) {
      await this.downloadData(this.id)
      breadcrumbs.push({ path: '', name: this.form.name })
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    } else {
      breadcrumbs.push({
        path: '',
        name: i18n.t('groups.new_group')
      })
      if (this.role !== 7 && this.role !== 8 && this.role !== 3) {
        const template = await getGroupTemplate()
        if (template.blnError === true) {
          this.doFeedback(`${template.msgError} [${template.codError}]`)
        }
        this.setTemplate(template.respuesta)
      }
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted () {
  },
  methods: {
    getDefaultForm: function () {
      return {
        id: 2,
        name: '',
        email: '',
        tipo: 2,
        EnUso: false,
        company: '',
        active: false,
        clienteId: '',
        verTodoGroups: true,
        verTodoStatuses: true,
        verTodoCompanies: true,
        EnviarAvisos: false,
        EnviarAvisosUsuarios: false,
        EmailAvisoNuevaEmitida: '',
        EmailAvisoNuevaRecibida: '',
        EmailAvisoCambioEstado: '',
        EmailAvisoVinculaciones: '',
      }
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    watchFormHandler: function ({
      certificate,
      send_alerts
    }) {},
    watchFormHandlerTipo: function () {
      // Gestion y GestorInvoiZE
      // Reparto
      if (this.form.tipo === 3) {
        this.form.verTodoGroups = false
        this.form.verTodoCompanies = false
        this.form.verTodoStatuses = false
      }
    },
    submitForm: function (formName) {
      if (this.isCreate) {
        this.newGroupHandler(formName)
      } else {
        this.updateGroupHandler(formName)
      }
    },
    newGroupHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // TODO Dependiendo del tipo de grupo
          const params = {
            idCliente: this.form.clienteId,
            Nombre: this.form.name,
            Emails: this.form.email,
            idTipo: this.form.tipo,
            verTodoGrupos: this.form.verTodoGroups,
            VerTodoEstados: this.form.verTodoStatuses,
            VerTodoEmpresas: this.form.verTodoCompanies,
            EnviarAvisos: this.form.EnviarAvisos,
            EnviarAvisosUsuarios: this.form.EnviarAvisosUsuarios,
            EmailAvisoNuevaEmitida: this.form.EmailAvisoNuevaEmitida,
            EmailAvisoNuevaRecibida: this.form.EmailAvisoNuevaRecibida,
            EmailAvisoCambioEstado: this.form.EmailAvisoCambioEstado,
            EmailAvisoVinculaciones: this.form.EmailAvisoVinculaciones,
          }
          const response = await newGroup(params)
          if (response.blnError === true) {
            this.doFeedback(`${response.msgError} [${response.codError}]`)
          } else {
            this.resetForm()
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            if (this.role !== 7 && this.role !== 8 && this.role !== 3) {
              const template = await getGroupTemplate()
              if (template.blnError === true) {
                this.doFeedback(`${template.msgError} [${template.codError}]`)
              }
              this.setTemplate(template.respuesta)
            } else {
              this.form = this.getDefaultForm()
            }
            this.resetForm()
            // setTimeout(() => {
            //   this.resetForm()
            // }, 100)
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        callback(new Error(i18n.t('validation.email_multiple')))
      } else if (value.length > this.maxLengthCorreos) {
        callback(new Error(i18n.t('validation.email_length', { n_chars: i18n.tc('app.n_character', this.maxLengthCorreos) })))
      } else {
        callback()
      }
    },
    updateGroupHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // TODO Dependiendo del tipo de grupo
          const params = {
            idGrupo: this.form.id,
            Nombre: this.form.name,
            Emails: this.form.email,
            verTodoGrupos: this.form.verTodoGroups,
            VerTodoEstados: this.form.verTodoStatuses,
            VerTodoEmpresas: this.form.verTodoCompanies,
            EnviarAvisos: this.form.EnviarAvisos,
            EnviarAvisosUsuarios: this.form.EnviarAvisosUsuarios,
            EmailAvisoNuevaEmitida: this.form.EmailAvisoNuevaEmitida,
            EmailAvisoNuevaRecibida: this.form.EmailAvisoNuevaRecibida,
            EmailAvisoCambioEstado: this.form.EmailAvisoCambioEstado,
            EmailAvisoVinculaciones: this.form.EmailAvisoVinculaciones,
          }
          const response = await updateGroup(params)
          if (response.blnError === false) {
            this.disableRoutes()
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.updateView()
            this.$store.commit('setAjaxRequestPending', false)
          } else {
            this.doFeedback(`${response.msgError} [${response.codError}]`)
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    disableRoutes: function () {
      const objDisableRoutes = {
        disableUsers: this.form.tipo === 3,
        disableStatuses: this.form.tipo === 1 || this.form.tipo === 3 || this.form.verTodoStatuses,
        disableCompanies: this.form.tipo === 1 || this.form.tipo === 3 || this.form.verTodoCompanies,
      }
      bus.$emit('disableOptionsGroup', objDisableRoutes)
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/groups' })
    },
    downloadData: async function (id) {
      let grupo = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idGrupo: id
        }
        grupo = await getGroup(params)
        this.setGroup(grupo.Respuesta)
        this.disableRoutes(grupo.Respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return grupo
    },
    setTemplate (group) {
      this.form.clienteId = null
      this.form.name = ''
      this.form.tipo = 2
      this.form.verTodoGroups = group.VerTodoGrupos
      this.form.verTodoStatuses = group.VerTodoEstados
      this.form.verTodoCompanies = group.VerTodoEmpresas
      this.form.EnviarAvisos = group.EnviarAvisos
      this.form.EnviarAvisosUsuarios = group.EnviarAvisosUsuarios
      this.form.EmailAvisoNuevaEmitida = group.EmailAvisoNuevaEmitida
      this.form.EmailAvisoNuevaRecibida = group.EmailAvisoNuevaRecibida
      this.form.EmailAvisoCambioEstado = group.EmailAvisoCambioEstado
      this.form.EmailAvisoVinculaciones = group.EmailAvisoVinculaciones
    },
    setGroup: function (group) {
      this.form.id = group.IdGrupo
      this.form.name = group.Nombre
      this.form.email = group.Emails
      this.form.tipo = group.idTipo
      this.form.EnUso = group.EnUso
      this.form.clienteId = group.idCliente
      this.form.verTodoGroups = group.VerTodoGrupos
      this.form.verTodoStatuses = group.VerTodoEstados
      this.form.verTodoCompanies = group.VerTodoEmpresas
      this.form.EnviarAvisos = group.EnviarAvisos
      this.form.EnviarAvisosUsuarios = group.EnviarAvisosUsuarios
      this.form.EmailAvisoNuevaEmitida = group.EmailAvisoNuevaEmitida
      this.form.EmailAvisoNuevaRecibida = group.EmailAvisoNuevaRecibida
      this.form.EmailAvisoCambioEstado = group.EmailAvisoCambioEstado
      this.form.EmailAvisoVinculaciones = group.EmailAvisoVinculaciones

      this.disableRoutes()
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
